import {
  Box,
  LinearProgress,
  Modal,
  Stack,
  Typography
} from "@mui/material";
import React, { useEffect, type FC } from "react";


interface Props {
  state: boolean;
  setState: React.Dispatch<React.SetStateAction<boolean>>;
}

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: "90vw",
  minHeight: "90vh",
  bgcolor: 'transparent',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  borderRadius: "10px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};

export const RecogniseOrder: FC<Props> = (props) => {
  const { state, setState } = props
  const handleClose = () => {
    setState(false)
  }

  // const handleProductsGet = useCallback(async () => {
  //   try {
  //     const url = '/api/order-guide?page=1&limit=1000';

  //     const requestOptions: { method: string } = {
  //       method: "GET",
  //     };

  //     const response = await fetch(url, requestOptions);

  //     if (response.ok) {
  //       const res = await response.json();

  //       const { data } = res.data;
  //       setProductList(data)
  //     }
  //   } catch (err) {
  //     console.error(err);
  //   }
  // }, []);

  useEffect(() => {
    // handleProductsGet()
  }, [])

  return <>
    <Modal
      open={state}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Stack
          display="grid"
          gap={1}
          sx={{
            width: "100%"
          }}>
          <Typography variant="h6" sx={{ color: "white" }} textAlign="center">AI is converting your order....Please hang tight</Typography>
          <LinearProgress sx={{
            width: "100%",
            height: 10,
            border: "2px solid white",
            borderRadius: 10
          }} variant="determinate" value={30} />
        </Stack>
      </Box>
    </Modal >
  </>
}
